import moment from "moment";
import { useEffect, useState } from "react";
import { CommonDateNUser } from "src/api/public-types";
import { isMobilePath, ViewYmdFormat } from "src/utils";
import { ArticleSection } from "./layout/ArticleSection";
import BaseSection from "./layout/BaseSection";
import { useLocation } from "react-router-dom";
/**
 * 등록정보 공용 컴포넌트
 * @param obj any
 * @returns
 */
const extractRelevantData = (obj: any): CommonDateNUser => {
  return {
    createdBy: obj?.createdBy ?? "",
    modifiedBy: obj?.modifiedBy ?? "",
    createdDate: obj?.createdDate ?? "",
    modifiedDate: obj?.modifiedDate ?? "",
    lastModifiedBy: obj?.lastModifiedBy ?? "",
    lastModifiedDate: obj?.lastModifiedDate ?? "",
  };
};

const RegistrationInformation = ({ data, dateFormat = ViewYmdFormat.YYYY_MM_DD_HH_MM }: any) => {
  const [infoData, setInfoData] = useState<CommonDateNUser>({
    createdBy: "",
    modifiedBy: "",
    createdDate: "",
    modifiedDate: "",
    lastModifiedBy: "",
    lastModifiedDate: "",
  });
  const { pathname } = useLocation();

  useEffect(() => {
    const extractedData = extractRelevantData(data);
    setInfoData(extractedData);
  }, [data]);

  if (isMobilePath(pathname)) return null;
  return (
    <ArticleSection
      title={"등록 정보"}
      children={
        <>
          <div className="flex-center">
            <BaseSection
              title={"최초 등록일시"}
              value={infoData?.createdDate ? moment(infoData?.createdDate).format(dateFormat) : "-"}
            />
            <BaseSection title={"최초 등록자"} value={infoData?.createdBy ? infoData?.createdBy : "-"} />
          </div>
          <div className="flex-center">
            <BaseSection
              title={"최종 수정일시"}
              value={
                infoData?.modifiedDate
                  ? moment(infoData?.modifiedDate).format(dateFormat)
                  : infoData?.lastModifiedDate
                    ? moment(infoData?.lastModifiedDate).format(dateFormat)
                    : "-"
              }
            />
            <BaseSection
              title={"최종 수정자"}
              value={infoData?.modifiedBy ? infoData?.modifiedBy : infoData?.lastModifiedBy ? infoData?.lastModifiedBy : "-"}
            />
          </div>
        </>
      }
    />
  );
};

export default RegistrationInformation;
